import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminApiService } from 'app/services/admin-api.service';
import { ModalComponent } from 'app/shared/modal/modal.component';
import { ModalService } from 'app/shared/modal/modal.service';
import CustomValidators from 'app/shared/custom-validators';
import { RegionDto, RoleDto, SessionUser, UserDto } from '@system-shared/classes.dto';
import { forkJoin, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-admin-manage-permits',
    templateUrl: './manage-permits.component.html',
    styleUrls: ['./manage-permits.scss'],
    standalone: false
})
export class AdminManagePermitsComponent implements OnInit {
  roleFormValid = false;
  loading: boolean = true;
  managePermitOpen: boolean = false;
  managePermitForm: FormGroup;
  showModal: boolean = false;
  modalConfig: { closeButtonText: string; title: string; body: string; confirmButtonText: string };

  permit;
  permitId: string;

  remarksLength: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private adminApiService: AdminApiService,
    private modalService: ModalService
  ) {
  }

  ngOnInit() {
    this.initForm();
    forkJoin([this.route.params.pipe(take(1)), this.route.data.pipe(take(1))])
    .subscribe((res) => {
      const params = res[0];

      this.permitId = params.id;
      this.adminApiService.getPermitById(this.permitId).subscribe((permit) => {
        this.permit = permit;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        if (error.status === 404) {
          this.router.navigate(['404']);
        }
      });
    });
  };


  initForm() {
    this.managePermitForm = this.formBuilder.group({
      email_radio: [null, Validators.required],
      new_email_address: [{value: null, disabled: true}, [Validators.maxLength(50), Validators.email, Validators.pattern(CustomValidators.emailPattern)]],
      remarks: [null, [Validators.maxLength(150)]],
    }, {
      validators: []
    });

    this.onChanges();
  };

  onChanges() {
    this.managePermitForm.controls.email_radio.valueChanges.subscribe((val) => {
      if (val == 'new_email') {
        this.managePermitForm.controls.new_email_address.enable();
        this.managePermitForm.controls.new_email_address.addValidators(Validators.required);
      } else {
        this.managePermitForm.controls.new_email_address.removeValidators(Validators.required);
        this.managePermitForm.controls.new_email_address.disable();
        this.managePermitForm.controls.new_email_address.setValue(null);
      }

      this.managePermitForm.controls.new_email_address.updateValueAndValidity();

    });
  }

  remarksChanged(remarks: string) {
    if (!remarks || !remarks.length) {
      this.remarksLength = 0;
    } else {
      this.remarksLength = remarks.length;
    }
  }

  submit() {
    if (this.managePermitForm.valid) {
      const data = {
        newEmail: this.managePermitForm.value.new_email_address,
        remarks: this.managePermitForm.value.remarks
      };

      this.emailPermit(data);
    }
  }

  emailPermit(data) {
    this.loading = true;
    this.adminApiService.emailPDFbyId(this.permitId, data).subscribe({
      next: () => {
        this.loading = false;
        this.showEmailButtonModal();
        this.managePermitOpen = false;
        this.managePermitForm.reset();
      }, error: (err) => {
        console.log(err);
        this.showEmailFailModal();
        this.loading = false;
      }
    })
  }

  showEmailSuccessModal() {
    const modalConfig = {
      title: 'Success!',
      body: 'Your email has been sent successfully',
      icon: '<i class="icon fas fa-check-circle"></i>'
    };
    this.modalService.open(modalConfig);
  }

  showEmailFailModal() {
    const modalConfig = {
      title: 'Error!',
      body: 'Your email has not been sent, due to server error',
      icon: '<i class="icon fas fa-times-circle"></i>'
    };
    this.modalService.open(modalConfig);
  }

  showEmailButtonModal() {
    this.modalConfig = {
      title: 'Success!',
      body: 'Your action has been successfully completed',
      confirmButtonText: 'Close',
      closeButtonText: null,
    };
    this.openModal();
  }

  closeModal() {
    this.showModal = false;
  }

  confirmModal() {
    this.showModal = false;
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  openModal() {
    this.showModal = true;
  }


}
